var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconIntegrations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "6158f4e79d4467c4ded7b039_icon-integrations.svg",
    clipPath: "url(#clip0_13_389)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval-Copy-10",
    d: "M22.5 45.6375C34.9264 45.6375 45 35.5639 45 23.1375C45 10.711 34.9264 0.637451 22.5 0.637451C10.0736 0.637451 0 10.711 0 23.1375C0 35.5639 10.0736 45.6375 22.5 45.6375Z",
    fill: "#2350F1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    d: "M20.6948 15.6375H15.5025C14.8652 15.6375 14.3486 16.154 14.3486 16.7913V21.4067C14.3486 22.0439 14.8652 22.5605 15.5025 22.5605H20.6948C21.332 22.5605 21.8486 22.0439 21.8486 21.4067V16.7913C21.8486 16.154 21.332 15.6375 20.6948 15.6375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2",
    d: "M20.6948 24.2913H15.5025C14.8652 24.2913 14.3486 24.8079 14.3486 25.4452V30.0606C14.3486 30.6978 14.8652 31.2144 15.5025 31.2144H20.6948C21.332 31.2144 21.8486 30.6978 21.8486 30.0606V25.4452C21.8486 24.8079 21.332 24.2913 20.6948 24.2913Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-Copy-66",
    d: "M29.9255 15.6375H24.7332C24.0959 15.6375 23.5793 16.154 23.5793 16.7913V21.4067C23.5793 22.0439 24.0959 22.5605 24.7332 22.5605H29.9255C30.5628 22.5605 31.0793 22.0439 31.0793 21.4067V16.7913C31.0793 16.154 30.5628 15.6375 29.9255 15.6375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-Copy-67",
    d: "M29.3486 24.8682H25.3101C24.6728 24.8682 24.1562 25.3848 24.1562 26.0221V29.4836C24.1562 30.1209 24.6728 30.6375 25.3101 30.6375H29.3486C29.9858 30.6375 30.5024 30.1209 30.5024 29.4836V26.0221C30.5024 25.3848 29.9858 24.8682 29.3486 24.8682Z",
    stroke: "white",
    strokeWidth: 1.15385
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_389"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white",
    transform: "translate(0 0.637451)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIntegrations);
export default __webpack_public_path__ + "static/media/icon-integrations.3515f6a7218f94d2f1f5df6960a95cd4.svg";
export { ForwardRef as ReactComponent };